import { HelpSubMenuItem } from '@ftr/ui-help'
import { SideNavItem } from '../side-nav-item'

export function toSideNavItem(item: HelpSubMenuItem): SideNavItem {
  if (item.isElevio) {
    // No onSelect — click is captured by the elevio script via the CSS class
    return { type: 'BUTTON', title: item.title } as SideNavItem
  }
  return {
    type: 'BUTTON',
    title: item.title,
    onSelect: () => window.open(item.link!, '_blank'),
  }
}
